import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import'rxjs/add/operator/map';
import'rxjs/add/operator/catch';
import'rxjs/add/observable/throw';

import { AuthConfiguration } from '../modules/auth.configuration';
import { OidcSecurityCommon } from './oidc.security.common';
import { AuthWellKnownEndpoints } from './auth.well-known-endpoints';
export class OidcSecurityUserService {

    userData: any;
/**
 * @param {?} http
 * @param {?} authConfiguration
 * @param {?} oidcSecurityCommon
 * @param {?} authWellKnownEndpoints
 */
constructor(
private http: Http,
private authConfiguration: AuthConfiguration,
private oidcSecurityCommon: OidcSecurityCommon,
private authWellKnownEndpoints: AuthWellKnownEndpoints
    ) {

        if (this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_user_data) !== '') {
            this.userData = this.oidcSecurityCommon.retrieve(this.oidcSecurityCommon.storage_user_data);
        }
    }
/**
 * @return {?}
 */
initUserData() {
        return this.getIdentityUserData()
            .map(data => this.userData = data);
    }
private getIdentityUserData = (): Observable<any> => {

        let /** @type {?} */ headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        let /** @type {?} */ token = this.oidcSecurityCommon.getAccessToken();

        if (token !== '') {
            headers.append('Authorization', 'Bearer ' + token);
        }

        return this.http.get(this.authWellKnownEndpoints.userinfo_endpoint, {
            headers: headers,
            body: ''
        }).map((res: any) => res.json());
    }
/**
 * @param {?} error
 * @return {?}
 */
private handleError(error: any) {
        this.oidcSecurityCommon.logError(error);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: AuthConfiguration, },
{type: OidcSecurityCommon, },
{type: AuthWellKnownEndpoints, },
];
}

function OidcSecurityUserService_tsickle_Closure_declarations() {
/** @type {?} */
OidcSecurityUserService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OidcSecurityUserService.ctorParameters;
/** @type {?} */
OidcSecurityUserService.prototype.userData;
/** @type {?} */
OidcSecurityUserService.prototype.getIdentityUserData;
/** @type {?} */
OidcSecurityUserService.prototype.http;
/** @type {?} */
OidcSecurityUserService.prototype.authConfiguration;
/** @type {?} */
OidcSecurityUserService.prototype.oidcSecurityCommon;
/** @type {?} */
OidcSecurityUserService.prototype.authWellKnownEndpoints;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
